export default __webpack_public_path__ + "static/media/CEO Img.28cf1592.png";